import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

export default function Index() {
  const { type, url } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (type) 
      navigate(`/login?type=${type}`);
    else
      navigate(`/login?url=${url}`);
  }, []);

  return (
    <>Redirecting...</>
  );
}